import React, { useState, useEffect } from "react";
import TimezoneSelect from "react-timezone-select";
import { CountryDropdown } from "react-country-region-selector";
import { Button, Card, Col, Row, Spinner } from 'react-bootstrap';
import {
  Label, FormGroup, FormFeedback, Input, Modal,
  ModalBody, ModalFooter, ModalHeader, InputGroup, Container
} from "reactstrap";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { password, repassword, user_tel, GetSchema } from '../../js/Base/ValidationSchema';
import toastAlert from '../../js/Base/ToastAlert';
import ProjectSelector from "../../components/Common/ProjectSelector";
import {
  getAccountById,
  updateAccount,
  changePassword
} from "../../api/accountApi";

export default function User() {
  const acctUuid = localStorage.getItem("user_uuid");
  const [projectNo, setProjectNo] = useState(() => {
    return localStorage.getItem("project_uuid") || "";
  });
  const ProjectRefresh = (newProjectNo) => {
    setProjectNo(newProjectNo);
  };

  const [initialValues, setInitialValues] = useState({
    name: "",
    email: "",
    tel: "",
    timezone: "",
    country : "",
    address: "",
    introduction: "",
  });

  // 修改密碼
  const [pwd, setPwd] = useState({ old_pwd: "", password: "", repassword: "" });
  const [modal, setModal] = useState(false);
  const [editPwdError, setEditPwdError] = useState(false);
  const toggleModal = () => setModal(!modal);
  const togglePwdErrorModal = () => setEditPwdError(!editPwdError);

  useEffect(() => {
    getAccountByNo();
  }, []);

  const getAccountByNo = async () => {
    if (!acctUuid) {
      toastAlert.autoClose(true).showError("查無資料，請聯絡系統管理員");
      return;
    }

    try {
      const res = await getAccountById(acctUuid);
      const data = res.data;

      if (data.success && data.account) {
        setInitialValues({
          name: data.account.name || "",
          email: data.account.email || "",
          tel: data.account.tel || "",
          timezone: data.account.timezone || "",
          country: data.account.country || "",
          address: data.account.address || "",
          introduction: data.account.introduction || "",
        });
      } else {
        toastAlert.autoClose(true).showError("發生錯誤，請稍後再試");
      }

    } catch (error) {
      if (error.__handled) return;
      toastAlert.autoClose(true).showError("發生錯誤，請稍後再試");
    }
  };

  const formUserDataSchema = GetSchema({
    tel: user_tel,
  });

  const handleUserDataEditSubmit = async (values, { setSubmitting }) => {
    if (!acctUuid) {
      toastAlert.autoClose(true).showError("查無資料，請聯絡系統管理員");
      setSubmitting(false);
      return;
    }

    try {
      const userData = { ...values, acct_uuid: acctUuid };
  
      const response = await updateAccount(userData);
      const data = response.data;

      if (data.success) {
        toastAlert.autoClose(true).showSuccess("更新成功");
      } else {
        toastAlert.autoClose(true).showError("更新失敗，請稍後再試");
      }

    } catch (error) {
      if (error.__handled) return;
      toastAlert.autoClose(true).showError("更新失敗，請稍後再試");
    } finally {
      setSubmitting(false);
    }
  };

  const formPWDSchema = GetSchema({
    old_pwd: password(),
    password: password(),
    repassword: repassword("password"),
  });

  const handleChangePassword = async (acct_uuid, old_pwd, new_pwd) => {
    try {
      const res = await changePassword({ acct_uuid, old_pwd, new_pwd });
      const result = res.data;

      if (result.success) {
        toggleModal();
      } else {
        togglePwdErrorModal();
      }
    } catch (error) {
      if (error.__handled) return;
      togglePwdErrorModal();
    }
  };

  const handleUserDataPWDEditSubmit = async (values, { setSubmitting, resetForm }) => {
    await handleChangePassword(acctUuid, values.old_pwd, values.password);
    setSubmitting(false);
    resetForm();
  };

  const modalFooter = {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingTop: '20px',
    marginBottom: '10px',
  };

  const modalButton = {
    width: '95px',
    height: '36px',
    padding: '0px',
    margin: '0px',
    fontSize: '14px',
  };

  return (
    <>
      <Modal className="LoginManagement" color="danger" isOpen={editPwdError} toggle={togglePwdErrorModal} style={{ top: "25px" }}>
        <ModalHeader toggle={togglePwdErrorModal}>修改失敗</ModalHeader>
        <ModalBody>修改密碼失敗，請確認輸入的舊密碼。</ModalBody>
        <ModalFooter style={modalFooter}>
          <Button className="btn-custom" style={modalButton} onClick={togglePwdErrorModal}>
          確定
          </Button>
        </ModalFooter>
      </Modal>

      <Modal className="LoginManagement" isOpen={modal} toggle={toggleModal} style={{ top: "25px" }}>
        <ModalHeader toggle={toggleModal}>修改</ModalHeader>
        <ModalBody>密碼修改成功！</ModalBody>
        <ModalFooter style={modalFooter}>
        <Button className="btn-custom" style={modalButton} onClick={toggleModal}>
          確定
          </Button>
        </ModalFooter>
      </Modal>

      <React.Fragment>
        <Container className="mt-2">
          <Row className="align-items-start mb-4 LoginManagement">
            <Col xs="12" sm="8" md="7">
              <Formik
                enableReinitialize
                initialValues={initialValues}
                validationSchema={formUserDataSchema}
                onSubmit={handleUserDataEditSubmit}
              >
                {({ errors, touched, isSubmitting, values, handleChange }) => (
                  <Card className="mt-3">
                    <Card.Header style={{ backgroundColor: '#F2F2F2' }}>
                      <strong className="card-title">基本資料修改</strong>
                    </Card.Header>
                    <Form>
                      <Card.Body>
                        <FormGroup>
                          <Label className="card-label" htmlFor="email">帳號</Label>
                          <h5 style={{ textAlign: 'center',paddingLeft: '5px' }}>
                            <strong>{values.email}</strong>
                          </h5>
                        </FormGroup>
                        <FormGroup>
                          <Label className="card-label" htmlFor="user_name">姓名</Label>
                          <Field name="user_name" id="user_name" type="text" >
                            {({ field }) => (
                              <Input
                                {...field}
                                type="text"
                                id="user_name"
                                maxLength="30"
                                disabled={true}
                                name="name"
                                value={values.name}
                              ></Input>
                            )}
                          </Field>
                          <ErrorMessage name="user_name">
                            {(msg) => <FormFeedback>{msg}</FormFeedback>}
                          </ErrorMessage>
                        </FormGroup>
                        <FormGroup>
                        <Label className="card-label" htmlFor="tel">公開電話(ex: 886-02-12345678)</Label>
                        <Field name="tel">
                          {({ field }) => (
                            <Input
                              {...field}
                              id="tel"
                              type="text"
                              maxLength="30"
                              placeholder="886-02-12345678"
                              invalid={errors.tel}
                            />
                          )}
                        </Field>
                        <ErrorMessage name="tel">
                          {(msg) => <FormFeedback>{msg}</FormFeedback>}
                        </ErrorMessage>
                        </FormGroup>
                        <FormGroup>
                          <Label className="card-label" htmlFor="country">國家</Label>
                          <Field name="country">
                            {({ field, form }) => (
                              <CountryDropdown
                                id="country"
                                name="country"
                                className="form-control"
                                value={field.value || ""}
                                onChange={(val) => form.setFieldValue("country", val)}
                              />
                            )}
                          </Field>
                        </FormGroup>
                        <FormGroup>
                          <Label className="card-label" htmlFor="timezone">時區</Label>
                          <Field name="timezone">
                            {({ field, form }) => (
                              <TimezoneSelect
                                value={field.value || ""}
                                onChange={(tz) => form.setFieldValue("timezone", tz.value)}
                              />
                            )}
                          </Field>
                        </FormGroup>
                        <FormGroup>
                          <Label className="card-label" htmlFor="language">顯示語系</Label>
                          <Field name="language">
                            {({ field }) => (
                              <Input {...field} type="select" id="language">
                                <option value="zh-TW">正體中文</option>
                                <option value="zh-CN">简体中文</option>
                                <option value="en-US">English</option>
                              </Input>
                            )}
                          </Field>
                          <ErrorMessage name="language">
                            {(msg) => <FormFeedback>{msg}</FormFeedback>}
                          </ErrorMessage>
                        </FormGroup>
                        <FormGroup>
                          <Label className="card-label" htmlFor="introduction">自我簡介</Label>
                          <Field name="introduction">
                            {({ field }) => (
                              <Input
                                {...field}
                                id="introduction"
                                placeholder="自我簡介"
                                maxLength="200"
                                type="textarea"
                                rows="4"
                              />
                            )}
                          </Field>
                          <ErrorMessage name="introduction">
                            {(msg) => <FormFeedback>{msg}</FormFeedback>}
                          </ErrorMessage>
                        </FormGroup>
                      </Card.Body>
                      <Card.Footer
                        style={{
                          display: 'flex',
                          justifyContent: 'flex-end',
                          paddingBottom: '28px',
                          paddingRight: '26px',
                          paddingTop: '20px',
                          backgroundColor: 'transparent',
                          height: '85px',
                        }}
                      >
                        <Button
                          type="submit"
                          className="btn btn-custom"
                          // style={{ width: '95px', height: '36px', fontSize: '14px' }}
                          disabled={isSubmitting}
                        >
                          儲存
                        </Button>
                      </Card.Footer>
                    </Form>
                  </Card>
                )}
              </Formik>
            </Col>
            <Col xs="12" sm="4" md="5">
              <Card className="mt-3 mb-3">
                <Card.Header style={{ backgroundColor: '#F2F2F2' }}>
                  <strong className="card-title">切換當前專案</strong>
                </Card.Header>
                <Card.Body style={{ margin:'5px 0'}}>
                  <ProjectSelector projectSelect={ProjectRefresh} style={{ fontSize: '12px', color: '#1d1d1d' }} />
                </Card.Body>
              </Card>
              <Formik
                initialValues={pwd}
                onSubmit={handleUserDataPWDEditSubmit}
                validationSchema={formPWDSchema}
              >
                {({ errors, touched, isSubmitting, values, handleChange }) => (
                  <Card>
                    <Card.Header style={{ backgroundColor: '#F2F2F2' }}>
                      <strong className="card-title">密碼修改</strong>
                    </Card.Header>
                    <Form>
                    <Card.Body>
                        <FormGroup>
                          <Label className="card-label" htmlFor="old_pwd">舊密碼</Label>
                          <Field name="old_pwd" id="old_pwd" type="password">
                            {({ field }) => (
                              <Input
                                {...field}
                                type="password"
                                id="old_pwd"
                                invalid={errors.old_pwd && touched.old_pwd}
                              ></Input>
                            )}
                          </Field>
                          <ErrorMessage name="old_pwd">{(msg) => <FormFeedback>{msg}</FormFeedback>}</ErrorMessage>
                        </FormGroup>
                        <FormGroup>
                          <Label className="card-label" htmlFor="password">新密碼</Label>
                          <Field name="password" id="password" type="password">
                            {({ field }) => (
                              <Input
                                {...field}
                                type="password"
                                id="password"
                                invalid={errors.password && touched.password}
                              ></Input>
                            )}
                          </Field>
                          <ErrorMessage name="password">{(msg) => <FormFeedback>{msg}</FormFeedback>}</ErrorMessage>
                        </FormGroup>
                        <FormGroup>
                          <Label className="card-label" htmlFor="repassword">確認新密碼</Label>
                          <Field name="repassword" id="repassword" type="password">
                            {({ field }) => (
                              <Input
                                {...field}
                                type="password"
                                id="repassword"
                                invalid={errors.repassword && touched.repassword}
                              ></Input>
                            )}
                          </Field>
                          <ErrorMessage name="repassword">
                            {(msg) => <FormFeedback>{msg}</FormFeedback>}
                          </ErrorMessage>
                        </FormGroup>
                      </Card.Body>
                      <Card.Footer
                        style={{
                          display: 'flex',
                          justifyContent: 'flex-end',
                          paddingBottom: '28px',
                          paddingRight: '26px',
                          paddingTop: '20px',
                          backgroundColor: 'transparent',
                          height: '85px',
                        }}
                      >
                        <Button
                          type="submit"
                          className="btn btn-custom"
                          disabled={isSubmitting}
                        >
                          修改
                        </Button>
                      </Card.Footer>
                    </Form>
                  </Card>
                )}
              </Formik>
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    </>
  );
}
